import { DOUBLE_HYPHEN_BULLET } from '@/shared/config';

/**
 * Formats a Bioflux Direct device id for display. Substitutes the double-hyphen bullet placeholder for the all-zero id and passes any other id through unchanged.
 *
 * @param deviceId - Device id reported for the Bioflux Direct record.
 * @returns The device id, or the placeholder for the all-zero id.
 */
const formatDeviceBiodirect = (deviceId: any) => {
  if (deviceId === '0000000000') {
    return DOUBLE_HYPHEN_BULLET;
  }

  return deviceId;
};

export { formatDeviceBiodirect };
